import { render } from "./AddOrEditMerchantOrder.vue?vue&type=template&id=62faa5ae&ts=true"
import script from "./AddOrEditMerchantOrder.vue?vue&type=script&lang=ts"
export * from "./AddOrEditMerchantOrder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__